module.exports = __webpack_public_path__ + "fonts/SuisseIntlCondensed-Regular.1faddbf.woff2";